import { useEffect } from 'react';
import './PurchaseOrder.css';
import { useNavigate } from 'react-router-dom';

function PublicPurchaseOrderViewOld() {
  const navigate = useNavigate();

  useEffect(() => {
    const url = window.location.href;
    const purchaseOrderNumber = url.split('/').pop();

    navigate('/purchaseOrder/'+purchaseOrderNumber);
  }, []);

  return (
    <>
      <p>Redirecting...</p>
    </>
  );
}

export default PublicPurchaseOrderViewOld;
